import {request} from "./request";
import {config} from "./config";

function isLogin(data, cb, fail_cb) {
    request.get.call(this, config.apiList.isLogin, data, cb, fail_cb)
}
function logout(data, cb, fail_cb) {
    request.get.call(this, config.apiList.logout, data, cb, fail_cb)
}

var loginApi = {
    isLogin: isLogin,
    logout: logout
}

export {
    loginApi
}